import { Block } from './Block.js'
import { Id } from '../utils/Id.js'

export class View extends Block {
  constructor({ content, page, title, wrapper }) {
    super(wrapper.lastElementChild, page, Id('view'), 'View', false)

    this._contentString = content.outerHTML
    this._DOM = null
    this.title = title
    this.wrapper = wrapper
    this.slug = content.dataset.view
  }

  onEnter() {}

  onEnterCompleted() {}

  onLeave() {}

  onLeaveCompleted() {}

  update() {
    document.title = this.title
    this.wrapper.appendChild(this._DOM.firstElementChild)
    this.el = this.wrapper.lastElementChild
    this._DOM = null
  }

  createDom() {
    if (!this._DOM) {
      this._DOM = document.createElement('div')
      this._DOM.innerHTML = this._contentString
    }
  }

  remove() {
    this.wrapper.firstElementChild.remove()
    if (HubSpotForms) HubSpotForms.removeAll()
  }

  enter(transition, trigger) {
    return new Promise((resolve) => {
      this.init()
      this.addEvents()
      this.onEnter()

      transition.enter({ trigger, to: this.el }).then(() => {
        this.onEnterCompleted()
        resolve()
      })
    })
  }

  leave(transition, trigger, removeOldContent) {
    return new Promise((resolve) => {
      this.onLeave()

      const oldViewId = this.el.dataset.view

      transition.leave({ trigger, from: this.el }).then(() => {
        if (removeOldContent) {
          this.remove()
        }

        this.onLeaveCompleted()
        this.destroy(transition, oldViewId)
        resolve()
      })
    })
  }
}
